export const getters = {

    columns: state => state.columns,
    model: state => state.model,
    model_order: state => state.model_order,
    relation_model: state => state.relation_model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
    prices: state => state.prices,
    patient_list: state => state.patient_list,
    order_list: state => state.order_list,
    hospital_list: state => state.hospital_list,
    order_pagination: state => state.order_pagination,
    hospital_pagination: state => state.hospital_pagination,
    patient_medicine: state => state.patient_medicine,
};
